import { Injectable } from "@angular/core";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { FormulateDates2Service } from "../formulate-dates/formulate-dates2.service";

export const QUOTER_CONSUMER_2019_STARTDATE = "1/1/2021";
export const QUOTER_PROFESSIONAL_2019_STARTDATE = "1/1/2020";
export const QUOTER_FRF_STARTDATE = "8/1/2023";
export const QUOTER_FRF_PREVIEW_DATE = "10/31/2023";
export const QUOTER_RFF_2025_DATE = "1/1/2025";

export const I18N_MONTH_VALUES = {
    'chi': {
        months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    },
    'en': {
        months: ['January', 'Feburary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    },
    'es': {
        months: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    },
    'zh': {
        months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    }
};

@Injectable({
    providedIn: "root"
})
export class CalcDatesService {

    constructor(
        private formulateDateService: FormulateDates2Service,
        private translate: TranslateService) {
    }

    isFrfMode(dt: Date | moment.Moment, isRenewal: boolean | null) {
        if (!dt) {
            return false;
        }

        const dtm = dt.toISOString ? dt : moment(dt, "YYYY MM DD");
        if (!isRenewal) {
            return dtm >= moment(QUOTER_FRF_STARTDATE);
        }
        else {
            return dtm >= moment(QUOTER_FRF_PREVIEW_DATE).add(1, 'd');
        }
    }

    toDate(dt: Date | moment.Moment): Date {
        let cdt = moment.isMoment(dt) ? dt.toDate() : dt instanceof Date ? dt : new Date(dt);
        cdt.setHours(0, 0, 0, 0);

        return cdt;
    }

    getMinStartDate() {
        const dt = this.formulateDateService.getMinStartDate();
        return { year: dt.year(), month: dt.month() + 1, day: dt.date() };
    }

    getMaxStartDate() {
        const dt = this.formulateDateService.getMaxStartDate();
        return { year: dt.year(), month: dt.month() + 1, day: dt.date() };
    }

    getCurrentDate() {
        return this.formulateDateService.getCurrentDate();
    }

    serviceDates() {
        const sdt = this.formulateDateService.getMinStartDate();
        const edt = this.formulateDateService.getMaxStartDate();

        let ret = [];
        for(let i = sdt.year(); i <= edt.year(); i++)  {
            ret.push(i);
        }
        return ret;
    }

    parseStartDate(dtInput: NgbDateStruct | string) {
        let startDate = moment();

        if (typeof dtInput === 'string' || dtInput instanceof String) {
            startDate = null;
        } else if (dtInput) {
            startDate.month(dtInput.month - 1);
            startDate.date(dtInput.day);
            startDate.year(dtInput.year);
            startDate.hour(0);
            startDate.minute(0);
            startDate.second(0);
        } else {
            startDate = null;
        }

        return startDate;
    }

    isValidDate(dt: moment.Moment) {
        return dt?.isValid()
    }

    isInRangeDate(dt: moment.Moment) {
        const startDate = this.formulateDateService.getMinStartDate();
        const endDate = this.formulateDateService.getMaxStartDate();
        
        if (dt > moment(startDate, "MM/DD/YYYY") && dt <= moment(endDate, "MM/DD/YYYY").add(1, 'd')) {
            return true;
        }

        return false;
    }

    getErrorMessage() {
        const startDate = this.formulateDateService.getMinStartDate();
        const endDate = this.formulateDateService.getMaxStartDate();

        let sdt = moment(startDate, "MM/DD/YYYY");
        let edt = moment(endDate, "MM/DD/YYYY");
        const lang = this.getLanguage();
        const stMonth = I18N_MONTH_VALUES[lang].months[sdt.month()];
        const edMonth = I18N_MONTH_VALUES[lang].months[edt.month()];

        return this.translate.instant("ERRORS.ROLLING_VALID_POLICY_START_DATE")
            .replace("[START_MONTH]", stMonth)
            .replace("[END_MONTH]", edMonth)
            .replace("[START_DAY]", sdt.date().toString())
            .replace("[END_DAY]", edt.date().toString())
            .replace("[START_YEAR]", sdt.year().toString())
            .replace("[END_YEAR]", edt.year().toString());
    }

    getMaxYearBuilt() {
        const endDate = this.formulateDateService.getMaxStartDate();

        let dt = moment(endDate, "MM/DD/YYYY");

        return dt.year();
    }

    getLanguage() {
        let lang = this.translate.currentLang ? this.translate.currentLang : this.translate.defaultLang
        if (lang === "kv") {
            lang = "en";
        }

        return lang;
    }

    isRff2025(dt) {
        const dtm = dt.toISOString ? dt : moment(dt, "YYYY MM DD");
        const rffDtm = moment(QUOTER_RFF_2025_DATE, "MM/DD/YYYY");

        return dtm.isAfter(rffDtm);
    }
}
